import type { PromotedContestsCollectionSlug } from '~/services/marketing/promoted-contests.schema';

export const CONDENSED_CAROUSELS_CACHE_TIME = 10 * 60 * 1000;

export const RAIL_RETRY_LIMIT = 1;

export const RAIL_RETRY_DELAY_MS = 300;

export type HomeCollectionSlug = Extract<PromotedContestsCollectionSlug, 'featured' | 'homepage'>;

const PROMOTED_CONTESTS_QUERY_KEY_PREFIX = 'promoted-contests';

export const CondensedCarouselsQueryKeys = {
  COLLECTION: (slug: PromotedContestsCollectionSlug) =>
    [PROMOTED_CONTESTS_QUERY_KEY_PREFIX, 'collection', slug] as const,
  CAROUSEL: ({ slug, carouselId }: { slug: string; carouselId: string }) =>
    [PROMOTED_CONTESTS_QUERY_KEY_PREFIX, 'carousel', slug, carouselId] as const,
  CAROUSEL_TAB: ({
    slug,
    carouselId,
    tabValue,
    contestIds,
    showPrivate,
    showFull,
    showInProgress,
    userId,
    locationKey,
  }: {
    slug: string;
    carouselId: string;
    tabValue: string;
    contestIds: readonly string[];
    showPrivate: boolean;
    showFull: boolean;
    showInProgress: boolean;
    userId: string | null;
    locationKey: string;
  }) =>
    [
      PROMOTED_CONTESTS_QUERY_KEY_PREFIX,
      'carousel',
      slug,
      carouselId,
      { tabValue, contestIds, showPrivate, showFull, showInProgress, userId, locationKey },
    ] as const,
};
